import React from "react";
import { Link } from "../Link";
import { Typography } from "@components/Typography";
import { ReactSVG } from "react-svg";
import { checkValidURL } from "@/utils/formHelper";
import { SocialMediaBlockProps } from "./types";

import "./styles.scss";

export const SocialMediaBlock = ({ socialNetwork }: SocialMediaBlockProps) => {
  const { name, id, text, url } = socialNetwork;
  return (
    <div className="social-block">
      <Link
        externalLink
        href={checkValidURL(url.value) || ""}
        className="social-block__icon"
        aria-label="social-link"
      >
        <ReactSVG className="social-block__icon" src={`/svg/icon-${id}.svg`} />
      </Link>
      <div className="social-block__text">
        <Link
          externalLink
          href={checkValidURL(url.value) || ""}
          aria-label="social-link"
        >
          <Typography
            Tag="p"
            size="m"
            classname="u-bold social-block__name u-spacing-0"
          >
            {name}
          </Typography>
        </Link>
        {text?.value && (
          <Typography
            Tag="p"
            size="m"
            classname="social-block__description u-spacing-0"
          >
            {text.value}
          </Typography>
        )}
      </div>
    </div>
  );
};
